module.exports = __webpack_public_path__ + "img/SA.7c204d15.png";